export default __webpack_public_path__ + "static/media/Thermometer.2145bbef.svg";